import { connect } from 'react-redux'
import LicenseAccessEdit from '../../components/LicenseAccess/LicenseAccessEdit'
import {updateLicense} from "../../actions/index";


const mapStateToProps = state => {
    return {
        emails: state.users.emails
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        updateLicense: (data) => {
            return dispatch(updateLicense(data));
        }
    }
};


export default connect(
    mapStateToProps,
    mapDispatchToProps

)(LicenseAccessEdit);
